import { IIconProps } from '../interfaces';

const AleaChevronDownIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '50'
}) => (
  <svg width={size} height={size} viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.1094 21.6665L25.1094 28.6665L32.1094 21.6665" stroke={color} strokeWidth="1.33333" strokeLinecap="round"/>
  </svg>
);

export default AleaChevronDownIcon;
